import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { SharedModule } from "../../../shared/shared.module";
import { UiModule } from "../../../ui/ui.module";
import { NotifyModule } from "../../../notify/notify.module";
import { MultiSelectModule } from "primeng/multiselect";
import { QuoteAiComponent } from "./quote-ai.component";
import { PopoverModule } from "primeng/popover";
import { QuoteRepository } from "app/quote/quote.repository";

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    UiModule,
    NotifyModule,
    MultiSelectModule,
    PopoverModule,
    QuoteAiComponent,
  ],
  providers: [QuoteRepository],
  exports: [QuoteAiComponent],
})
export class QuoteAiModule {}
